import { IsNotEmpty, IsString, MaxLength, IsInt, IsUUID } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class PricelistItemEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsInt()
    price: number;

    @IsNotEmpty()
    @IsUUID()
    product: string;

    @IsNotEmpty()
    @IsUUID()
    pricelist: string;

}
